// eslint-disable-next-line no-shadow
enum ECrossAxisGranularityType {
    TIME = 'time',
}

export default ECrossAxisGranularityType
